var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTempo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "#000000ff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    opacity: 1,
    d: " M 12.00 4.00 C 20.00 4.00 28.00 4.00 36.00 4.00 C 36.00 8.02 36.00 12.03 36.00 16.04 C 33.35 18.74 30.66 21.38 28.01 24.07 C 30.66 26.74 33.34 29.39 35.99 32.06 C 36.00 36.04 36.00 40.02 36.00 44.00 C 28.00 44.00 20.00 44.00 12.00 44.00 C 12.00 40.02 12.00 36.05 12.00 32.07 C 14.64 29.42 17.29 26.78 19.94 24.14 C 17.30 21.47 14.63 18.84 12.00 16.18 C 12.00 12.12 12.00 8.06 12.00 4.00 M 16.00 8.00 C 16.00 10.35 16.00 12.71 16.00 15.06 C 18.66 17.73 21.32 20.40 24.00 23.06 C 26.68 20.40 29.34 17.73 32.00 15.06 C 32.00 12.71 32.00 10.36 32.00 8.00 C 26.67 8.00 21.33 8.00 16.00 8.00 M 16.01 33.06 C 16.00 35.37 16.00 37.68 16.00 40.00 C 21.33 40.00 26.67 40.00 32.00 40.00 C 32.00 37.69 32.00 35.38 32.00 33.07 C 29.34 30.40 26.67 27.73 24.00 25.07 C 21.33 27.73 18.67 30.39 16.01 33.06 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempo);
export default __webpack_public_path__ + "static/media/tempo.6c9f347ee8d8a1e2638823c05eab6130.svg";
export { ForwardRef as ReactComponent };